import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import ReminderNotifier from "@/components/ReminderNotifier";
import InstallBanner from "@/components/InstallBanner";
import Landing from "@/pages/Landing";
import AdLanding from "@/pages/AdLanding";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import CaseIntake from "@/pages/CaseIntake";
import CaseDetail from "@/pages/CaseDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Playbooks from "@/pages/Playbooks";
import PlaybookDetail from "@/pages/PlaybookDetail";
import Referrals from "@/pages/Referrals";
import ChargebackGuide from "@/pages/ChargebackGuide";
import FounderProfile from "@/pages/FounderProfile";
import Founding100 from "@/pages/Founding100";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import StartRedirect from "@/pages/StartRedirect";
import AdDownloads from "@/pages/AdDownloads";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <ReminderNotifier />
        <InstallBanner />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/start" element={<StartRedirect />} />
          <Route path="/l/:variant" element={<AdLanding />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/playbooks" element={<Playbooks />} />
          <Route path="/playbooks/:slug" element={<PlaybookDetail />} />
          <Route path="/chargeback-guide" element={<ChargebackGuide />} />
          <Route path="/founder/:number" element={<FounderProfile />} />
          <Route path="/founding-100" element={<Founding100 />} />
          <Route path="/ad-kit" element={<AdDownloads />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/case/new" element={<Protected><CaseIntake /></Protected>} />
          <Route path="/case/:id" element={<Protected><CaseDetail /></Protected>} />
          <Route path="/referrals" element={<Protected><Referrals /></Protected>} />
          <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
          <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
